<template>
  <div class="productListing">
    <div
      style="position: fixed; width: 100%; top: 0; z-index: 99"
      id="couponcode-list"
    >
      <div
        class="coupon-code"
        v-if="couponResponse && couponResponse.length"
        v-for="coupon in couponResponse"
      >
        <div class="left-part">
          <p>
            <strong>Rs {{ coupon.discountedAmount }}/- OFF</strong> on Min Order
            <strong>Rs {{ coupon.minimumOrderAmount }}</strong
            >.<br />Valid only for
            <strong v-if="coupon.paymentMethod === 'COD'">COD Payments</strong>
            <strong v-else-if="coupon.paymentMethod === 'ONLINE'"
              >Online Payments</strong
            >
            <strong v-else>TODAY</strong>!
          </p>
        </div>
        <div class="right-part flx">
          <p>
            <input
              type="text"
              :value="coupon.couponCode"
              readonly
              :id="coupon.couponCode"
            />
            <br /><span>User Code</span>
          </p>
          <span class="icon" @click="copyTestingCode(coupon.couponCode)"
            ><CopyIcon
          /></span>
        </div>
      </div>
      <div class="dummy-coupon onTop" v-if="$store.state.dummyCouponCode">
        <p>
          <span
            >यह कूपन उपयोग कर सकते थे , अगर पिछले आर्डर शेयर किये होते |</span
          ><span class="code">{{ $store.state.dummyCouponCode }}</span>
        </p>
      </div>
    </div>
    <section
      class="detail_content"
      :style="`padding-top:${couponCardHeight + 43}px`"
    >
      <header
        class="main_customHeading"
        style="justify-content: space-between"
        :style="`top:${couponCardHeight}px`"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="16"
          viewBox="0 0 20 16"
          @click="goBack()"
        >
          <g fill="#000" fill-rule="evenodd">
            <path
              d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
            />
            <path
              d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
            />
          </g>
        </svg>
        <h2>{{ $t("productList") }}</h2>
        <div class="icon_wrapper flx" style="justify-content: flex-end">
          <span class="tabIcon" @click="goToCart()">
            <span
              class="one-cart-size"
              v-if="cartSize > 0"
              style="top: 5px; right: 4px"
              >{{ cartSize }}</span
            >
            <span class="add-no">{{ cartSize }}</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="20"
              viewBox="0 0 21 26"
            >
              <g>
                <path
                  fill="#505050"
                  d="M20.986 21.44L19.804 6.81c-.074-.943-.886-1.681-1.849-1.681H15.62v-.103C15.62 2.255 13.323 0 10.5 0S5.381 2.255 5.381 5.026v.103H3.045c-.963 0-1.775.738-1.848 1.679L.014 21.443c-.092 1.172.322 2.338 1.135 3.2C1.963 25.505 3.116 26 4.313 26h12.374c1.197 0 2.35-.495 3.164-1.357.813-.862 1.227-2.028 1.135-3.202zM6.932 5.027c0-1.932 1.6-3.503 3.568-3.503 1.967 0 3.568 1.571 3.568 3.503v.103H6.932v-.103zm11.78 18.582c-.528.56-1.247.87-2.025.87H4.313c-.778 0-1.497-.31-2.025-.87-.529-.56-.787-1.288-.728-2.047L2.743 6.926c.012-.154.145-.274.302-.274h2.336v1.875c0 .42.347.762.776.762.428 0 .775-.341.775-.762V6.652h7.136v1.875c0 .42.347.762.776.762.428 0 .775-.341.775-.762V6.652h2.336c.157 0 .29.12.302.276L19.44 21.56c.06.761-.199 1.49-.727 2.05z"
                />
              </g>
            </svg>
          </span>
        </div>
      </header>
      <div
        class="bottom_filter"
        v-if="
          [
            'LATEST_COLLECTION_PRODUCTS',
            'TOP_SELLING_PRODUCTS',
            'NORMAL',
            'GMALL_FACTORY_PRODUCTS',
            'LOCAL_SUPPLY_PRODUCTS',
            'LIFESTYLE',
            'BRAND',
          ].includes(this.type)
        "
      >
        <div class="item" @click="sortProduct = !sortProduct">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
          >
            <g fill="#0091FF">
              <path
                d="M11.535 15.349H8.977a.31.31 0 00-.23.09.312.312 0 00-.09.23v1.918c0 .094.03.17.09.23s.137.09.23.09h2.558a.31.31 0 00.23-.09.31.31 0 00.09-.23V15.67a.31.31 0 00-.09-.23.31.31 0 00-.23-.09zM6.739 14.07H4.82V.32c0-.093-.03-.17-.09-.23A.312.312 0 004.5 0H2.583c-.093 0-.17.03-.23.09a.312.312 0 00-.09.23v13.75H.344c-.147 0-.247.066-.3.2-.054.126-.03.243.07.35l3.197 3.197c.074.06.15.09.23.09.087 0 .163-.03.23-.09l3.188-3.188c.066-.08.1-.16.1-.24 0-.093-.03-.17-.09-.23a.312.312 0 00-.23-.09zM13.454 10.233H8.977c-.093 0-.17.03-.23.09a.311.311 0 00-.09.23v1.918c0 .093.03.17.09.23s.137.09.23.09h4.477a.31.31 0 00.23-.09.31.31 0 00.09-.23v-1.919a.31.31 0 00-.09-.23.31.31 0 00-.23-.09zM17.521.09a.312.312 0 00-.23-.09H8.977c-.093 0-.17.03-.23.09a.312.312 0 00-.09.23v1.918c0 .094.03.17.09.23s.137.09.23.09h8.314c.094 0 .17-.03.23-.09s.09-.136.09-.23V.32c0-.093-.03-.17-.09-.23zM15.373 5.116H8.977c-.093 0-.17.03-.23.09a.312.312 0 00-.09.23v1.919c0 .093.03.17.09.23s.137.09.23.09h6.396c.093 0 .17-.03.23-.09s.09-.137.09-.23V5.436c0-.093-.03-.17-.09-.23a.313.313 0 00-.23-.09z"
              />
            </g>
          </svg>
          <span>
            {{ $t("sort") }}
            <strong v-if="sortOption">.</strong>
          </span>
        </div>
        <div
          class="item filter"
          @click="viewAllCat()"
          style="border-left: 1px solid rgba(0, 0, 0, 0.28)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14.346"
            height="14.346"
            viewBox="0 0 14.346 14.346"
          >
            <path
              id="ic_filter"
              d="M13.673-17.5h-13A.673.673,0,0,0,.2-16.352L5.38-11.169V-5.4a.673.673,0,0,0,.287.551L7.908-3.276a.673.673,0,0,0,1.058-.551v-7.342l5.182-5.183A.673.673,0,0,0,13.673-17.5Z"
              transform="translate(0 17.5)"
              fill="#fff"
            />
          </svg>
          <span>
            {{ $t("filter") }}
            <strong v-if="appliedFilter">.</strong>
          </span>
        </div>
      </div>
      <div class="bottomToUp" v-if="sortProduct"></div>
      <div
        class="bottomToUp_content"
        :class="{ activeBottomtoUp: sortProduct }"
      >
        <div class="popup_content sort">
          <h5 class="prdt_hdng">{{ $t("sortBy") }}</h5>
          <ul class="sort-item">
            <li
              @click="sortByPrice('PRODUCT_RANK', 'DESC')"
              :class="{
                sortOption:
                  sortOption === 'PRODUCT_RANK' && sortByValue === 'DESC',
              }"
              v-if="$route.query.type === 'TOP_SELLING_PRODUCTS'"
            >
              {{ $t("mostSellingItems") }}
            </li>
            <li
              @click="sortByPrice('ITEM_DATE', 'DESC')"
              :class="{
                sortOption:
                  sortOption === 'ITEM_DATE' && sortByValue === 'DESC',
              }"
              v-else
            >
              {{ $t("whatsNew") }}
            </li>
            <li
              @click="sortByPrice('PRICE', 'ASC')"
              :class="{
                sortOption: sortOption === 'PRICE' && sortByValue === 'ASC',
              }"
            >
              {{ $t("priceLowToHigh") }}
            </li>
            <li
              @click="sortByPrice('PRICE', 'DESC')"
              :class="{
                sortOption: sortOption === 'PRICE' && sortByValue === 'DESC',
              }"
            >
              {{ $t("priceHighToLow") }}
            </li>
          </ul>
        </div>
        <span class="closePopUp" @click="sortProduct = !sortProduct">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="23"
            viewBox="0 0 23 23"
          >
            <path
              fill="#CDCDCD"
              fill-rule="nonzero"
              d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
              opacity=".675"
            />
          </svg>
        </span>
      </div>
      <CategoryFilterOption
        :dataValue="filterProducts"
        @closeAllCat="closeAllCat"
        @closeAllCatFromHeader="closeAllCatFromHeader"
        @getFilterList="getAppliedFilterList"
        :isFilterOption="isFilterOption"
        :class="{ hideClass: !isDisplay }"
        @getFilterClear="getClearFilter"
        :couponCardHeight="couponCardHeight"
      />
      <div :class="{ hideClass: isDisplay }" class="product_listing_detail">
        <CategoryFilter
          :dataValue="filterProducts"
          @selectedCategory="getProductByCategory"
          @viewAllCat="viewAllCat()"
          :selectedcategoryName="selectedcategoryName"
          :choosedCatId="choosedCatId"
          :couponCardHeight="couponCardHeight"
        />

        <div class="filter_product_list" v-if="salesProducts.length > 0">
          <h3
            class="section_heading"
            style="width: 100%"
            v-if="$route.query.type == 'GMALL_FACTORY_PRODUCTS'"
          >
            {{ this.$t("qualityProductTitle") }}
          </h3>
          <h3
            class="section_heading"
            style="width: 100%"
            v-if="$route.query.type == 'LATEST_COLLECTION_PRODUCTS'"
          >
            {{ this.$t("latestCollection") }}
          </h3>
          <h3
            class="section_heading"
            style="width: 100%"
            v-if="$route.query.type == 'TOP_SELLING_PRODUCTS'"
          >
            {{ this.$t("topSelling") }}
          </h3>
          <h3
            class="section_heading"
            style="width: 100%"
            v-if="$route.query.type == 'LOCAL_SUPPLY_PRODUCTS'"
          >
            {{ this.$t("dailyProduct") }}
          </h3>
          <h3
            class="section_heading"
            style="width: 100%"
            v-if="$route.query.type == 'BRAND'"
          >
            {{ this.$route.query.brandName }}
          </h3>
          <div
            ref="container"
            class="filter_card"
            v-for="(product, index) in salesProducts"
            :class="{ 'new-item-card': isTileView === 'LIST_VIEW' }"
            :key="index"
          >
            <img
              src="../assets/images/icons/verified-icon.png"
              alt="loader"
              class="mVerified-Icon"
              v-if="product.sellerLiteDTO.isApproved"
            />
            <p
              class="home-delivery-text"
              v-if="
                product.sellerLiteDTO.sellerShopSettingDTO &&
                product.sellerLiteDTO.sellerShopSettingDTO
                  .homeDeliveryAvailable &&
                isTileView === 'LIST_VIEW'
              "
            >
              FREE HOME DELIVERY
            </p>
            <div
              class="img_wrapper spinner_wrapper"
              v-lazyload
              v-if="product.displayImage"
              @click="goToProductDetail(product.sellerItemRelationshipId)"
            >
              <ImageSpinner class="image_spinner" />
              <img :data-url="product.displayImage" alt />
            </div>
            <div
              class="img_wrapper spinner_wrapper"
              v-else
              @click="goToProductDetail(product.sellerItemRelationshipId)"
            >
              <img src="../assets/images/watermark1.jpg" alt="item" />
            </div>
            <div class="product_detail">
              <p class="product-name">{{ product.productName }}</p>
              <p
                class="bought rating"
                style="display: flex"
                v-if="parseFloat(product.averageRating) > 0"
              >
                <star-rating
                  :read-only="true"
                  :increment="0.01"
                  :starSize="10"
                  active-color="#138808"
                  :rating="Number(product.averageRating)"
                  :show-rating="false"
                ></star-rating>
                <span style="padding-left: 4px">
                  ({{ product.ratingNum }})</span
                >
              </p>
              <p
                class="bought rating"
                style="display: flex"
                v-else-if="
                  !product.averageRating &&
                  $store.state.isViewType === 'GRID_VIEW'
                "
              >
                No ratings yet
              </p>
              <div class="my_price_section flx">
                <span class="my_price" v-if="product.sellingPrice">
                  <span class="rupee-font">₹​</span>{{ product.sellingPrice }}
                  <span
                    class="sp-badge"
                    v-if="
                      parseFloat(product.mrp) >
                        parseFloat(product.sellingPriceWithoutDiscount) &&
                      $store.state.isViewType === 'LIST_VIEW'
                    "
                    >Your Price</span
                  >
                </span>
                <span
                  class="selling_price"
                  v-if="product.sellingPriceWithoutDiscount"
                  ><span class="rupee-font">₹​</span>​{{
                    product.sellingPriceWithoutDiscount
                  }}</span
                >
                <span
                  class="selling_price"
                  v-if="
                    parseFloat(product.mrp) >
                      parseFloat(product.sellingPriceWithoutDiscount) &&
                    product.mrp
                  "
                  ><span class="rupee-font">₹​</span>​{{ product.mrp }}</span
                >
              </div>
              <label
                class="price-less-tag"
                v-if="
                  parseFloat(product.mrp) > parseFloat(product.sellingPrice)
                "
                >{{
                  $t("lessWithXPrice", {
                    lessAmount: Math.round(
                      parseFloat(product.mrp) - parseFloat(product.sellingPrice)
                    ),
                  })
                }}
              </label>

              <p
                class="bought"
                style="color: black"
                @click="viewShop(product.sellerLiteDTO.shopId)"
              >
                {{ $t("shop") }} -
                <span style="color: green">{{
                  product.sellerLiteDTO.storeName
                }}</span>

                <!-- {{$t('peopleHaveBrought')}} -->
              </p>
              <p
                class="home-delivery-text"
                v-if="
                  product.sellerLiteDTO.sellerShopSettingDTO &&
                  product.sellerLiteDTO.sellerShopSettingDTO
                    .homeDeliveryAvailable &&
                  isTileView === 'GRID_VIEW'
                "
              >
                FREE HOME DELIVERY
              </p>
              <div v-if="$cookie.get('JWT-TOKEN')">
                <p
                  v-if="product.gmallProductId"
                  @click="goToProductDetail(product.sellerItemRelationshipId)"
                >
                  <ListQuantity
                    :dataQuantity="product"
                    @updateCartCount="getUpdatedCartCount"
                    @notLoggedInUser="checkUserIsLogin"
                  />
                </p>
                <p v-else>
                  <ListQuantity
                    :dataQuantity="product"
                    @updateCartCount="getUpdatedCartCount"
                    @notLoggedInUser="checkUserIsLogin"
                  />
                </p>
              </div>
              <div v-else>
                <div class="option_selection" @click="checkUserIsLogin()">
                  <div class="add-option">{{ $t("buyNow") }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <NoDataFound v-if="salesProductStatus" class="no_record" />
        <infinite-loading
          @infinite="getProductsListing"
          spinner="circles"
          :identifier="resetIdentifier"
          :class="{ errorLog: isErrorLog }"
        >
          <template slot="no-more" v-if="!salesProductStatus">{{
            $t("noMoreRecord")
          }}</template>
        </infinite-loading>

        <div class="cntntLoad" v-if="loading">
          <img src="../assets/images/loader.gif" alt="loader" />
        </div>
      </div>
    </section>
    <login-form v-if="isLogedInUser" @notLoggedInUser="checkUserIsLogin" />
    <div class="cntntLoad" v-if="blankLoad">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import constant from "../utils/constant";
import ApiCaller from "../utils/apicaller";
import CategoryFilter from "../components/ProductListSection/CategoryFilter";
import CategoryFilterOption from "../components/ProductListSection/CategoryFilterOption";
import ImageSpinner from "../components/Common/ImageSpinner";
import NoDataFound from "../components/Common/NoDataFound";
import YoutubeIcon from "@/components/Icons/YoutubeIcon";
import ListQuantity from "./ListQuantity";
import { mapState, mapMutations, mapGetters } from "vuex";
import types from "../store/types";
import CopyIcon from "@/components/Icons/CopyIcon";
import StarRating from "vue-star-rating";
import LoginForm from "@/components/ShopManagementSection/LoginForm";
export default {
  name: "ProductListing",
  watch: {
    goBack() {
      if (this.$cookie.get("version-code") > 57) {
        if (window.history.length == 1) {
          try {
            JSBridgePlugin.gotToHome();
          } catch (err) {
            console.log(err);
          }
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
  },
  components: {
    CategoryFilter,
    CategoryFilterOption,
    ImageSpinner,
    NoDataFound,
    CopyIcon,
    YoutubeIcon,
    ListQuantity,
    StarRating,
    LoginForm,
  },
  data() {
    return {
      appliedFilter: false,
      sortProduct: false,
      pageIndex: 0,
      type: "TRENDING",
      salesProducts: [],
      filterProducts: {},
      isDisplay: false,
      choosedCatId: 0,
      selectedcategoryName: "",
      isFilterOption: false,
      loading: false,
      noRecord: false,
      salesProductStatus: false,
      sortOption: "ITEM_DATE",
      sortByValue: "DESC",
      resetIdentifier: +new Date(),
      blankLoad: false,
      isErrorLog: false,
      filterMinPrice: null,
      filterMaxPrice: null,
      isTileView: "",
      couponCardHeight: "",
      isLogedInUser: false,
    };
  },
  computed: {
    ...mapState(["savePosition", "saveData"]),
    ...mapGetters(["couponResponse", "cartSize"]),
  },
  methods: {
    checkUserIsLogin() {
      this.$emit("notLoggedInUser");
    },
    openCouponChannel() {
      try {
        JSBridgePlugin.genericIntentLaunch(
          "https://www.youtube.com/channel/UCM-3he3y7nnnMT17z-6ZrTQ"
        );
      } catch {
        console.log("not allowed on browser");
      }
    },
    viewShop(sellID) {
      if (sellID && !this.$route.query.shopid) {
        this.$store.commit("saveCategories", {
          categories: [],
          catId: 0,
          catIndex: 0,
        });
        this.$store.commit(types.CATEGORY_PRODUCT, []);
        // mOST POPULAR
        this.$store.commit("saveData", {
          mostSellingItemList: [],
          mostSellingPageIndex: 0,
          type: "most_selling_item",
        });
        if (sellID != this.$route.query.shopid) {
          if (this.$route.query.source === "ADS_SERVER") {
            if (this.$route.query.campaignUnitIdentifier) {
              this.$router.push(
                "/daily-needs?shopid=" +
                  sellID +
                  "&typeOfSource=" +
                  this.$route.query.source +
                  "&campaignIdentifier=" +
                  this.$route.query.campaignIdentifier +
                  "&campaignUnitIdentifier=" +
                  this.$route.query.campaignUnitIdentifier
              );
            } else {
              this.$router.push(
                "/daily-needs?shopid=" +
                  sellID +
                  "&typeOfSource=" +
                  this.$route.query.source +
                  "&campaignIdentifier=" +
                  this.$route.query.campaignIdentifier
              );
            }
          } else {
            this.$router.push("/daily-needs?shopid=" + sellID);
          }
        } else {
          if (this.$route.query.source === "ADS_SERVER") {
            if (this.$route.query.campaignUnitIdentifier) {
              this.$router.push(
                "/daily-needs?shopid=" +
                  sellID +
                  "&typeOfSource=" +
                  this.$route.query.source +
                  "&campaignIdentifier=" +
                  this.$route.query.campaignIdentifier +
                  "&campaignUnitIdentifier=" +
                  this.$route.query.campaignUnitIdentifier
              );
            } else {
              this.$router.push(
                "/daily-needs?shopid=" +
                  sellID +
                  "&typeOfSource=" +
                  this.$route.query.source +
                  "&campaignIdentifier=" +
                  this.$route.query.campaignIdentifier
              );
            }
          } else {
            this.$router.push("/daily-needs?shopid=" + sellID);
          }
        }
      }
    },
    goToCart() {
      if (this.$cookie.get("JWT-TOKEN")) {
        if (this.$route.query.shopid) {
          this.$router.push(
            "/cart-check-out?source=LOCAL91_CATEGORY_BROWSING&shopid=" +
              this.$route.query.shopid
          );
        } else {
          this.$router.push("/cart-check-out?source=LOCAL91_CATEGORY_BROWSING");
        }
      } else {
        this.$emit("notLoggedInUser");
      }
    },
    copyTestingCode(whatsappNumber) {
      let el = document.getElementById(whatsappNumber);
      el.select();
      document.execCommand("copy");
    },
    getUpdatedCartCount() {
      this.$store.commit(
        types.UPDATE_CART_SIZE,
        Math.round(parseInt(this.cartSize) + 1)
      );
    },
    ...mapMutations(["setsavePosition"]),
    goBack() {
      if (this.$cookie.get("version-code") > 57) {
        if (window.history.length == 1) {
          try {
            JSBridgePlugin.gotToHome();
          } catch (err) {
            console.log(err);
          }
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
    viewAllCat() {
      this.isDisplay = true;
    },
    closeAllCatFromHeader() {
      this.isDisplay = false;
    },
    closeAllCat() {
      this.isDisplay = false;
      this.pageIndex = 0;
      this.$store.commit("saveCategoriesData", {
        categoriesPageIndex: this.pageIndex,
      });
      this.filterMaxPrice = 1000000;
      this.filterMinPrice = 0;
      this.salesProducts = [];
      this.resetIdentifier += 1;
    },
    getProductByCategory(data) {
      localStorage.removeItem("LandOnCategoryListingPage");
      this.appliedFilter = false;
      this.sortOption = "ITEM_DATE";
      this.sortByValue = "DESC";
      this.filterMaxPrice = 1000000;
      this.filterMinPrice = 0;
      this.loading = true;
      this.salesProductStatus = false;
      this.choosedCatId = parseInt(data.categoryId);
      this.pageIndex = 0;
      this.$store.commit("saveCategoriesData", {
        categoriesPageIndex: this.pageIndex,
      });
      this.salesProducts = [];
      this.resetIdentifier += 1;
    },
    sortByPrice(val, sortByValue) {
      localStorage.removeItem("LandOnCategoryListingPage");
      if (this.sortOption == val && this.sortByValue == sortByValue) {
        this.sortProduct = false;
        return;
      } else {
        this.sortOption = val;
        this.sortByValue = sortByValue;
        this.loading = true;
        this.pageIndex = 0;
        this.$store.commit("saveCategoriesData", {
          categoriesPageIndex: this.pageIndex,
        });
        this.salesProducts = [];
        this.resetIdentifier += 1;
      }
    },
    getAppliedFilterList(data) {
      this.filterMinPrice = data.minPrice;
      this.filterMaxPrice = data.maxPrice;
      this.appliedFilter = true;
      localStorage.removeItem("LandOnCategoryListingPage");
      this.appliedFilter = true;
      this.pageIndex = 0;
      this.$store.commit("saveCategoriesData", {
        categoriesPageIndex: this.pageIndex,
      });
      this.salesProducts = [];
      this.resetIdentifier += 1;
      this.isDisplay = false;
    },
    getClearFilter(data) {
      localStorage.removeItem("LandOnCategoryListingPage");
      if (data) {
        this.appliedFilter = true;
      } else {
        this.appliedFilter = false;
      }
    },
    goToProductDetail(productSrId) {
      // localStorage.removeItem('LandOnCategoryListingPage')
      if (
        (this.$route.query.typeOfSource &&
          this.$route.query.campaignIdentifier &&
          this.$route.query.campaignUnitIdentifier) ||
        (this.$route.query.source === "ADS_SERVER" &&
          this.$route.query.campaignIdentifier &&
          this.$route.query.campaignUnitIdentifier)
      ) {
        if (this.$route.query.typeOfSource) {
          this.$router.push(
            "/detail/" +
              productSrId +
              "?source=" +
              this.$route.query.typeOfSource +
              "&campaignIdentifier=" +
              this.$route.query.campaignIdentifier +
              "&shopid=" +
              this.$route.query.shopid +
              "&campaignUnitIdentifier=" +
              this.$route.query.campaignUnitIdentifier
          );
        } else if (
          this.$route.query.source === "ADS_SERVER" &&
          this.$route.query.campaignIdentifier &&
          this.$route.query.campaignIdentifier
        ) {
          this.$router.push(
            "/detail/" +
              productSrId +
              "?source=" +
              this.$route.query.source +
              "&campaignIdentifier=" +
              this.$route.query.campaignIdentifier +
              "&shopid=" +
              this.$route.query.shopid +
              "&campaignUnitIdentifier=" +
              this.$route.query.campaignUnitIdentifier
          );
        }
      } else if (
        (this.$route.query.typeOfSource &&
          this.$route.query.campaignIdentifier) ||
        (this.$route.query.source === "ADS_SERVER" &&
          this.$route.query.campaignIdentifier)
      ) {
        if (this.$route.query.typeOfSource) {
          this.$router.push(
            "/detail/" +
              productSrId +
              "?source=" +
              this.$route.query.typeOfSource +
              "&campaignIdentifier=" +
              this.$route.query.campaignIdentifier +
              "&shopid=" +
              this.$route.query.shopid
          );
        } else if (
          this.$route.query.source === "ADS_SERVER" &&
          this.$route.query.campaignIdentifier
        ) {
          this.$router.push(
            "/detail/" +
              productSrId +
              "?source=" +
              this.$route.query.source +
              "&campaignIdentifier=" +
              this.$route.query.campaignIdentifier +
              "&shopid=" +
              this.$route.query.shopid
          );
        }
      } else if (this.$route.query.shopid && this.$route.query.source) {
        this.$router.push(
          "/detail/" +
            productSrId +
            "?source=" +
            this.$route.query.source +
            "&shopid=" +
            this.$route.query.shopid
        );
      } else if (this.$route.query.shopid) {
        this.$router.push(
          "/detail/" +
            productSrId +
            "?source=LOCAL91_CATEGORY_BROWSING" +
            "&shopid=" +
            this.$route.query.shopid
        );
      } else if (this.$route.query.source) {
        this.$router.push(
          "/detail/" + productSrId + "?source=" + this.$route.query.source
        );
      } else if (
        [
          "LATEST_COLLECTION_PRODUCTS",
          "TOP_SELLING_PRODUCTS",
          "LIFESTYLE",
          "LOCAL_SUPPLY_PRODUCTS",
        ].includes(this.$route.query.type)
      ) {
        this.$router.push("/detail/" + productSrId + "?source=LIFESTYLE");
      } else if (this.$route.query.type) {
        this.$router.push(
          "/detail/" + productSrId + "?source=" + this.$route.query.type
        );
      } else {
        this.$router.push(
          "/detail/" + productSrId + "?source=LOCAL91_CATEGORY_BROWSING"
        );
      }
    },
    getSubCategory() {
      let payloadValue;
      if (this.$route.query.shopid) {
        payloadValue =
          this.$route.query.parentCatId + "?shopid=" + this.$route.query.shopid;
      } else {
        payloadValue = this.$route.query.parentCatId;
      }
      ApiCaller(
        constant.LOCAL_SHOP_URL,
        "get-category-tree/" + payloadValue,
        "get"
      )
        .then((data) => {
          if (data.data.childCategories) {
            this.filterProducts = data.data.childCategories;
            this.$store.commit("saveCategoryFilterData", {
              catfilterProdList: this.filterProducts,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    getProductsListing($state) {
      this.loading = true;
      let categoryId = 0;
      if (this.type == "NORMAL") {
        categoryId = categoryId;
      }
      if (this.$store.getters.categoriesPageIndex) {
        this.pageIndex = this.$store.getters.categoriesPageIndex;
      }
      this.$store.commit("saveCatTypeName", {
        catTypeName: this.type,
      });
      if (
        [
          "LATEST_COLLECTION_PRODUCTS",
          "TOP_SELLING_PRODUCTS",
          "NORMAL",
          "GMALL_FACTORY_PRODUCTS",
          "LIFESTYLE",
          "BRAND",
          "LOCAL_SUPPLY_PRODUCTS",
        ].includes(this.type)
      ) {
        if (this.pageIndex > 0) {
          localStorage.removeItem("LandOnCategoryListingPage");
        }
        const obj = {
          pageIndex: this.pageIndex,
          shopId: this.$route.query.shopid || null,
          categoryId: Number(this.choosedCatId) || null,
          sortField: this.sortOption,
          sortBy: this.sortByValue,
          filters: [],
        };
        if (this.type == "NORMAL" && this.filterMinPrice) {
          obj.filters.push({
            filterField: "PRICE",
            filterFieldValue: {
              value: null,
              minValue: this.filterMinPrice,
              maxValue: this.filterMaxPrice,
            },
          });
        } else if (this.type == "GMALL_FACTORY_PRODUCTS") {
          obj.filters.push(
            {
              filterField: "IS_LOCALSHOP_PRODUCTS",
              filterFieldValue: {
                value: true,
              },
            },
            {
              filterField: "INSTOCK",
              filterFieldValue: {
                value: true,
              },
            }
          );
          if (this.filterMinPrice) {
            obj.filters.push({
              filterField: "PRICE",
              filterFieldValue: {
                value: null,
                minValue: this.filterMinPrice,
                maxValue: this.filterMaxPrice,
              },
            });
          }
        } else if (this.type == "LATEST_COLLECTION_PRODUCTS") {
          obj.filters.push(
            {
              filterField: "IS_RETAILSHOP_PRODUCTS",
              filterFieldValue: {
                value: true,
              },
            },
            {
              filterField: "INSTOCK",
              filterFieldValue: {
                value: true,
              },
            }
          );
          if (this.filterMinPrice) {
            obj.filters.push({
              filterField: "PRICE",
              filterFieldValue: {
                value: null,
                minValue: this.filterMinPrice,
                maxValue: this.filterMaxPrice,
              },
            });
          }
        } else if (this.type == "TOP_SELLING_PRODUCTS") {
          obj.filters.push(
            {
              filterField: "IS_RETAILSHOP_PRODUCTS",
              filterFieldValue: {
                value: true,
              },
            },
            {
              filterField: "INSTOCK",
              filterFieldValue: {
                value: true,
              },
            }
          );
          if (this.filterMinPrice) {
            obj.filters.push({
              filterField: "PRICE",
              filterFieldValue: {
                value: null,
                minValue: this.filterMinPrice,
                maxValue: this.filterMaxPrice,
              },
            });
          }
        } else if (this.type == "LIFESTYLE" && Number(this.choosedCatId)) {
          obj.filters.push(
            {
              filterField: "IS_RETAILSHOP_PRODUCTS",
              filterFieldValue: {
                value: true,
              },
            },
            {
              filterField: "INSTOCK",
              filterFieldValue: {
                value: true,
              },
            }
          );
          if (this.filterMinPrice) {
            obj.filters.push({
              filterField: "PRICE",
              filterFieldValue: {
                value: null,
                minValue: this.filterMinPrice,
                maxValue: this.filterMaxPrice,
              },
            });
          }
        } else if (this.type == "BRAND" && this.$route.query.id) {
          obj.brandId = Number(this.$route.query.id);
          obj.filters.push(
            {
              filterField: "IS_RETAILSHOP_PRODUCTS",
              filterFieldValue: {
                value: true,
              },
            },
            {
              filterField: "INSTOCK",
              filterFieldValue: {
                value: true,
              },
            }
          );
          if (this.filterMinPrice) {
            obj.filters.push({
              filterField: "PRICE",
              filterFieldValue: {
                value: null,
                minValue: this.filterMinPrice,
                maxValue: this.filterMaxPrice,
              },
            });
          }
        } else if (this.type == "LOCAL_SUPPLY_PRODUCTS") {
          obj.filters.push(
            {
              filterField: "IS_GMALL_LOCAL_SUPPLY",
              filterFieldValue: {
                value: true,
              },
            },
            {
              filterField: "INSTOCK",
              filterFieldValue: {
                value: true,
              },
            }
          );
          if (this.filterMinPrice) {
            obj.filters.push({
              filterField: "PRICE",
              filterFieldValue: {
                value: null,
                minValue: this.filterMinPrice,
                maxValue: this.filterMaxPrice,
              },
            });
          }
        }
        // get-products-by-category-and-filters
        ApiCaller(
          constant.LOCAL_SHOP_URL,
          "localshop/get-products",
          "post",
          obj,
          "get"
        )
          .then((data) => {
            this.sortProduct = false;
            if (this.couponResponse && this.couponResponse.length) {
              var elmnt = document.getElementById("couponcode-list");
              if (elmnt) {
                this.couponCardHeight = elmnt.offsetHeight;
                console.log(elmnt.offsetHeight);
              }
            }
            if (
              data &&
              data.data.productListingDTOs &&
              data.data.productListingDTOs.length > 0
            ) {
              this.pageIndex = this.pageIndex + 1;
              this.salesProducts.push(...data.data.productListingDTOs);
              this.$store.commit("saveCategoriesData", {
                categoriesProdList: this.salesProducts,
                categoriesPageIndex: this.pageIndex,
              });
              this.loading = false;
              this.salesProductStatus = false;
              if (
                this.$route.query.source === "LUCKY_WHEEL_SCRATCH" &&
                localStorage.getItem("LandOnCategoryListingPage")
              ) {
                this.getCategoryTracking("LUCKY_WHEEL_SCRATCH");
              } else if (
                this.$route.query.source === "DAILY_LUCKY_SCRATCH" &&
                localStorage.getItem("LandOnCategoryListingPage")
              ) {
                this.getCategoryTracking("DAILY_LUCKY_SCRATCH");
              } else if (
                this.$route.query.source === "FUTURE_LUCKY_SCRATCH" &&
                localStorage.getItem("LandOnCategoryListingPage")
              ) {
                this.getCategoryTracking("FUTURE_LUCKY_SCRATCH");
              }
              $state && $state.loaded();
            } else {
              this.pageIndex = -1;
              this.loading = false;
              $state && $state.complete();
              if (
                this.$route.query.source === "LUCKY_WHEEL_SCRATCH" &&
                localStorage.getItem("LandOnCategoryListingPage")
              ) {
                this.getCategoryTracking("LUCKY_WHEEL_SCRATCH_NO_ITEMS");
              } else if (
                this.$route.query.source === "DAILY_LUCKY_SCRATCH" &&
                localStorage.getItem("LandOnCategoryListingPage")
              ) {
                this.getCategoryTracking("DAILY_LUCKY_SCRATCH_NO_ITEMS");
              } else if (
                this.$route.query.source === "FUTURE_LUCKY_SCRATCH" &&
                localStorage.getItem("LandOnCategoryListingPage")
              ) {
                this.getCategoryTracking("FUTURE_LUCKY_SCRATCH_NO_ITEMS");
              }
              if (this.salesProducts.length === 0) {
                this.salesProductStatus = true;
              }
            }
          })
          .catch((err) => {
            this.loading = false;
            this.isErrorLog = true;
            console.log(err);
          });
      } else if (this.type == "MOST_SELLING_PRODUCT") {
        if (!$state) {
          this.loading = true;
        }
        let payloadObject;
        if (this.$route.query.shopid) {
          payloadObject =
            this.pageIndex + "?shopid=" + this.$route.query.shopid;
        } else {
          payloadObject = this.pageIndex;
        }
        this.$store
          .dispatch({
            type: "getMostsellingProduct",
            payload: 20,
            index: payloadObject,
          })
          .then((data) => {
            this.loading = false;
            if (this.couponResponse && this.couponResponse.length) {
              var elmnt = document.getElementById("couponcode-list");
              if (elmnt) {
                this.couponCardHeight = elmnt.offsetHeight;
                console.log(elmnt.offsetHeight);
              }
            }
            if (data && data.data.productListingDTOs.length > 0) {
              this.pageIndex = this.pageIndex + 1;
              this.salesProducts.push(...data.data.productListingDTOs);
              this.$store.commit("saveCategoriesData", {
                categoriesProdList: this.salesProducts,
                categoriesPageIndex: this.pageIndex,
              });
              this.loading = false;
              this.salesProductStatus = false;
              if (
                this.$route.query.source === "LUCKY_WHEEL_SCRATCH" &&
                localStorage.getItem("LandOnCategoryListingPage")
              ) {
                this.getCategoryTracking("LUCKY_WHEEL_SCRATCH");
              } else if (
                this.$route.query.source === "DAILY_LUCKY_SCRATCH" &&
                localStorage.getItem("LandOnCategoryListingPage")
              ) {
                this.getCategoryTracking("DAILY_LUCKY_SCRATCH");
              } else if (
                this.$route.query.source === "FUTURE_LUCKY_SCRATCH" &&
                localStorage.getItem("LandOnCategoryListingPage")
              ) {
                this.getCategoryTracking("FUTURE_LUCKY_SCRATCH");
              }
              $state && $state.loaded();
            } else {
              this.pageIndex = -1;
              this.loading = false;
              $state && $state.complete();
              if (
                this.$route.query.source === "LUCKY_WHEEL_SCRATCH" &&
                localStorage.getItem("LandOnCategoryListingPage")
              ) {
                this.getCategoryTracking("LUCKY_WHEEL_SCRATCH_NO_ITEMS");
              } else if (
                this.$route.query.source === "DAILY_LUCKY_SCRATCH" &&
                localStorage.getItem("LandOnCategoryListingPage")
              ) {
                this.getCategoryTracking("DAILY_LUCKY_SCRATCH_NO_ITEMS");
              } else if (
                this.$route.query.source === "FUTURE_LUCKY_SCRATCH" &&
                localStorage.getItem("LandOnCategoryListingPage")
              ) {
                this.getCategoryTracking("FUTURE_LUCKY_SCRATCH_NO_ITEMS");
              }
              if (this.salesProducts.length === 0) {
                this.salesProductStatus = true;
              }
            }
          })
          .catch((err) => {
            this.loading = false;
            this.isErrorLog = true;
            console.log(err);
          });
      }
    },
    getCategoryTracking(sourceValue) {
      ApiCaller(
        constant.LOCAL_SHOP_URL,
        "add-user-traking/?orderSourceType=" + sourceValue,
        "post"
      )
        .then((data) => {})
        .catch((err) => {
          console.log(err);
        });
    },
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  mounted() {
    ApiCaller(constant.APP_SETTING_SERVICE_URL, "get-aap-settings", "get")
      .then((data) => {
        this.$store.commit("VIEW_TYPE", data.data[0].designStyle);
        this.isTileView = data.data[0].designStyle;
        console.log(this.$route.name);
        if (data.data[0].cloudShopUser) {
          if (this.$route.path == "/discount-kirana") {
            this.$store.commit("CLOUDSHOP_USER", false);
          } else {
            this.$store.commit("CLOUDSHOP_USER", data.data[0].cloudShopUser);
          }
        } else {
          this.$store.commit("CLOUDSHOP_USER", false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    if (this.$route.query.type === "TOP_SELLING_PRODUCTS") {
      this.sortOption = "PRODUCT_RANK";
    }

    localStorage.setItem("LandOnCategoryListingPage", true);
    if (this.$route.query.parentCatId) this.getSubCategory();
    this.choosedCatId = Number(this.$route.query.categoryid);
    if (this.$store.getters.catTypeName === this.$route.query.type) {
      if (this.$store.getters.catfilterProdList) {
        this.filterProducts = this.$store.getters.catfilterProdList;
      }
      if (
        this.$store.getters.categoriesProdList &&
        this.$store.getters.categoriesProdList.length > 0 &&
        this.$store.getters.categoriesPageIndex
      ) {
        this.salesProducts = this.$store.getters.categoriesProdList;
        this.pageIndex = this.$store.getters.categoriesPageIndex;
      }
    } else {
      this.pageIndex = 0;
      this.$store.commit("saveCategoriesData", {
        categoriesPageIndex: this.pageIndex,
      });
    }
    if (this.salesProducts.length == 0) {
      this.loading = true;
    } else {
      this.loading = false;
    }
    this.pageIndex = 0;
    if (this.$route.query.type && this.$route.query.type != null) {
      this.type = this.$route.query.type;
    } else {
      this.type = "NORMAL";
    }
  },
};
</script>
<style lang="scss" scoped>
.productListing .detail_content .main_customHeading.topZero {
  top: 0;
}
.productListing .detail_content .main_customHeading.topHeight {
  top: 44px;
}
.coupon-code {
  background: #042d49;
  color: #fff;
  // font-weight: 600;
  padding: 8px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  animation: ak 0.2s 1;
  border-bottom: 1px solid #000;
  // animation-delay: 5s;
  .left-part {
    width: 60%;
    font-size: 0.75em;
  }
  .right-part {
    width: 40%;
    justify-content: flex-end;
    p {
      padding-right: 8px;
      font-size: 0.875em;
      text-align: right;
      input {
        background: none;
        // width: 49%;
        color: #fff;
        font-weight: 600;
        text-align: right;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      span {
        font-weight: normal;
        color: #a3aeb5;
        font-size: 0.75em;
        display: block;
      }
    }
    .icon {
      background: #a3aeb5;
      display: block;
      width: 35px;
      height: 24px;
      padding: 5px;
      border-radius: 50%;
      .st0 {
        fill: none;
        stroke: #fff;
        stroke-width: 2;
        stroke-miterlimit: 10;
      }
      .st1 {
        fill: none;
        stroke: #fff;
        stroke-width: 2;
        stroke-miterlimit: 10;
        stroke-dasharray: 4.11, 4.11;
      }
    }
  }
}
@keyframes ak {
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    opacity: 1;
  }
}
p.product-name {
  font-size: 0.87em;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  white-space: nowrap;
  margin-bottom: 5px;
}
.sortOption {
  color: #0091ff;
}
.infinite-status-prompt {
  color: #fff !important;
}
.productListing .detail_content.paddingMore {
  padding-top: 85px;
}
</style>
